var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitterIconFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.998,
    r: 16,
    fill: "#fff",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.255 14.25c.01.151.01.302.01.455 0 4.652-3.278 10.018-9.27 10.018v-.003A8.73 8.73 0 018 23.14c.257.034.516.05.775.051 1.468.002 2.893-.53 4.047-1.51-1.394-.028-2.617-1.01-3.044-2.445.489.102.992.081 1.471-.06-1.52-.332-2.614-1.775-2.614-3.451v-.045c.453.273.96.424 1.48.44-1.432-1.033-1.874-3.091-1.01-4.7 1.655 2.2 4.096 3.536 6.716 3.678-.263-1.223.096-2.504.942-3.364 1.313-1.333 3.376-1.265 4.61.153a6.251 6.251 0 002.069-.855 3.5 3.5 0 01-1.432 1.947 6.105 6.105 0 001.87-.554 6.94 6.94 0 01-1.625 1.824z",
    fill: "#303996"
  })));
}

export default SvgTwitterIconFooter;